import { ApiUrl } from "src/services/apiUrls";

const ABSOLUTE_URL_PATTERN = /^(https?:)?\/\//i;

export const getImageUrl = (value, baseUrl = ApiUrl.IMAGE_BASE_URL) => {
  if (!value || typeof value !== "string") return "";

  const imagePath = value.trim().replace(/^["']|["']$/g, "");
  if (!imagePath) return "";

  if (imagePath.startsWith("gs://")) {
    return `https://storage.googleapis.com/${imagePath.replace(/^gs:\/\//, "")}`;
  }

  if (
    ABSOLUTE_URL_PATTERN.test(imagePath) ||
    imagePath.startsWith("blob:") ||
    imagePath.startsWith("data:") ||
    imagePath.startsWith("/")
  ) {
    return imagePath;
  }

  const normalizedBaseUrl = (baseUrl || "").replace(/\/+$/, "");
  const normalizedPath = imagePath.replace(/^\/+/, "");

  return normalizedBaseUrl ? `${normalizedBaseUrl}/${normalizedPath}` : normalizedPath;
};

export const getFileExtension = (value = "") => {
  if (typeof value !== "string") return "";
  const cleanValue = value.split("?")[0].split("#")[0];
  const extensionStart = cleanValue.lastIndexOf(".");
  return extensionStart === -1 ? "" : cleanValue.slice(extensionStart + 1).toLowerCase();
};
